import { useForm } from "react-hook-form";
import "./setter-top-client-table.css";
import { MdDelete, MdModeEdit } from "react-icons/md";
import Swal from "sweetalert2";
import {
  addData,
  getData,
  formService,
  getBtnEmmit,
  setConfirmationModal,
  formResetService,
  removeDataByIndex,
  updateDataByIndex
} from "./setter-form-service";
import { useEffect, useState } from "react";
import axios from "axios";
import { IoMdAdd } from "react-icons/io";
import { FaTimes } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";

// 👇 RECIBIMOS LA NUEVA PROP creditClientObj AQUÍ
function SetterCreditClientTable({ onModalToggle, creditClientObj }) {
  // 🔹 Estados principales simplificados
  const [records, setRecords] = useState([]); // almacena los embarques (shipments)
  const [isModalOpen, setIsModalOpen] = useState(false); // controla visibilidad del modal
  const [editIndex, setEditIndex] = useState(null); // índice del embarque que se edita

  // 🔹 Configuración de react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    formState: { errors, isSubmitted },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
  });

  let formBtnClick = false;

  // 🔹 Escucha global de envío de formulario (desde formService)
  useEffect(() => {
    const subscription = formService.formSubmitSubject.subscribe(async () => {
      const isValidForm = await trigger();
      if (isValidForm && getBtnEmmit()) {
        handleSubmit(setterSubmit)();
      } else if (!isValidForm && getBtnEmmit()) {
        if (getData().length < 1) {
          handleSubmit(setterSubmit)();
        } else {
          setConfirmationModal(true);
          return;
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [handleSubmit, trigger]);

  // 🔹 Resetea el formulario cuando otro componente lo solicita
  useEffect(() => {
    const subscription = formResetService.onReset().subscribe(() => {
      reset();
    });
    return () => subscription.unsubscribe();
  }, [reset]);

  // 🔹 Abre el modal y carga datos si es edición
  const openModal = (index = null) => {
    // 🌟 Validación de máximo 50 renglones
    if (index === null && records.length >= 50) {
      Swal.fire("Límite alcanzado", "Solo se permiten hasta 50 embarques por turno.", "warning");
      return;
    }

    setEditIndex(index);
    if (index !== null) {
      const record = records[index];
      reset(record);
    } else {
      clearForm();
      // 🌟 Lógica de autocompletado: toma la descripción del último embarque agregado (si existe)
      if (records.length > 0) {
        const lastRecord = records[records.length - 1];
        if (lastRecord.content) {
          setValue("content", lastRecord.content);
        }
      }
    }
    setIsModalOpen(true);
    if (onModalToggle) onModalToggle(true);
  };

  // 🔹 Limpia los valores del formulario
  const clearForm = () => {
    const fieldsToClear = ["content", "number_pallets", "awb"];
    fieldsToClear.forEach((field) => setValue(field, ""));
  };

  // 🔹 Cierra el modal y limpia el formulario
  const closeModal = () => {
    setIsModalOpen(false);
    clearForm();
    setEditIndex(null);
    if (onModalToggle) onModalToggle(false);
  };

  // 🔹 Elimina un embarque de la tabla y del servicio
  const handleDeleteRow = (index) => {
    Swal.fire({
      title: "¿Deseas borrar el turno?",
      iconHtml: `
     <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M75 0C116.423 0 150 33.5775 150 75C150 116.423 116.423 150 75 150C33.5775 150 0 116.423 0 75C0 33.5775 33.5775 0 75 0ZM75 105C73.0109 105 71.1032 105.79 69.6967 107.197C68.2902 108.603 67.5 110.511 67.5 112.5C67.5 114.489 68.2902 116.397 69.6967 117.803C71.1032 119.21 73.0109 120 75 120C76.9891 120 78.8968 119.21 80.3033 117.803C81.7098 116.397 82.5 114.489 82.5 112.5C82.5 110.511 81.7098 108.603 80.3033 107.197C78.8968 105.79 76.9891 105 75 105ZM75 33.75C67.7894 33.75 60.8742 36.6144 55.7755 41.713C50.6769 46.8117 47.8125 53.7269 47.8125 60.9375C47.8125 62.9266 48.6027 64.8343 50.0092 66.2408C51.4157 67.6473 53.3234 68.4375 55.3125 68.4375C57.3016 68.4375 59.2093 67.6473 60.6158 66.2408C62.0223 64.8343 62.8125 62.9266 62.8125 60.9375C62.815 58.7253 63.4195 56.5554 64.5614 54.6607C65.7032 52.7659 67.3392 51.2176 69.294 50.1819C71.2488 49.1462 73.4487 48.662 75.6577 48.7814C77.8667 48.9008 80.0015 49.6192 81.8333 50.8596C83.6651 52.0999 85.1248 53.8155 86.0557 55.8223C86.9867 57.8291 87.3539 60.0514 87.118 62.251C86.882 64.4506 86.0518 66.5445 84.7164 68.3082C83.381 70.0719 81.5907 71.4389 79.5375 72.2625C74.4675 74.2875 67.5 79.4775 67.5 88.125V90C67.5 91.9891 68.2902 93.8968 69.6967 95.3033C71.1032 96.7098 73.0109 97.5 75 97.5C76.9891 97.5 78.8968 96.7098 80.3033 95.3033C81.7098 93.8968 82.5 91.9891 82.5 90C82.5 88.17 82.875 87.255 84.4575 86.475L85.11 86.175C90.9661 83.8192 95.8203 79.4996 98.8405 73.9569C101.861 68.4141 102.859 61.9934 101.663 55.7954C100.468 49.5974 97.1541 44.0082 92.2893 39.986C87.4246 35.9638 81.3122 33.7592 75 33.75Z" fill="#035CF7"/>
      </svg>`,
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      customClass: {
        icon: "no-default-icon", 
        confirmButton: "btn-confirm",
        cancelButton: "btn-cancel"
      },
    }).then((result) => {
      if (result.isConfirmed) {
        removeDataByIndex(index);
        setRecords([...getData()]);
        Swal.fire("Eliminado", "El embarque ha sido eliminado.", "success");
      }
    });
  };

  // 🔹 Maneja el envío del formulario (agregar o actualizar embarque)
  const setterSubmit = async (data) => {
    // ⚠️ Esta es la estructura exacta que solicitaste (los 4 campos unicamente)
    const shipment = {
      // 👇 USAMOS EL NOMBRE QUE VIENE EN EL OBJETO (y si por alguna razón falla, ponemos un texto por defecto)
      customer_name: creditClientObj ? creditClientObj.name : "Cliente no encontrado", 
      content: data.content,
      number_pallets: data.number_pallets,
      awb: data.awb,
    };

    if (formBtnClick === false) {
      setConfirmationModal(true);
      return;
    }

    if (editIndex !== null) {
      const updated = [...records];
      updated[editIndex] = shipment;
      setRecords(updated);
      updateDataByIndex(editIndex, shipment);
      Swal.fire("Actualizado", "El embarque fue modificado", "success");
    } else {
      const newList = [...records, shipment];
      setRecords(newList);
      addData(shipment);
      Swal.fire("Agregado", "El embarque fue agregado correctamente", "success");
    }
    
    // 💡 NOTA: Si necesitas ver cómo queda la estructura final que pediste,
    // se vería algo así al momento de enviar tu petición principal (fuera de esta tabla):
    const payloadFinal = {
      shipments: getData(),
      user_id: localStorage.getItem('heavy-load-email')
    };
    console.log(JSON.stringify(payloadFinal, null, 2));

    closeModal();
  };

  return (
    <>
      <div className="records">
        <table className="table-format-shepments">
          <thead>
            <tr className="table-header">
              <th className="table-header-cell">Cliente</th>
              <th className="table-header-cell">Contenido</th>
              <th className="table-header-cell">Tarimas</th>
              <th className="table-header-cell">AWB</th>
              <th className="table-header-cell"></th>
            </tr>
          </thead>
          <tbody>
            {records.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center">
                  No hay embarques agregados credito.
                </td>
              </tr>
            ) : (
              records.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="borderStyle">{item.customer_name}</td>
                    <td className="borderStyle">{item.content}</td>
                    <td className="borderStyle">{item.number_pallets}</td>
                    <td className="borderStyle">{item.awb || "Sin AWB"}</td>
                    <td className="text-center actionTdSeek">
                      <div className="box-container seek-bg-red" onClick={() => handleDeleteRow(index)}>
                        <MdDelete />
                      </div>
                      <div className="box-container seek-bg-edit" onClick={() => openModal(index)}>
                        <MdModeEdit />
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      <button 
        className="btn-add-shipment" 
        disabled={isModalOpen || records.length >= 50}
        style={{ 
          opacity: (isModalOpen || records.length >= 50) ? 0.5 : 1, 
          cursor: (isModalOpen || records.length >= 50) ? 'not-allowed' : 'pointer' 
        }}
        onClick={() => openModal()}
      >
        <IoMdAdd /> Agregar embarque
      </button>

      {}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content-shipment">
            <button
              className="close-modal-btn"
              onClick={() => closeModal()}
            >
              <FaTimes />
            </button>
            <h5>
              Embarque {editIndex !== null ? editIndex + 1 : getData().length + 1}
            </h5>
            <form
              className="setter-form"
              autoComplete="off"
              onSubmit={handleSubmit(setterSubmit)}
            >
              <p>Ingresa los datos de los embarques</p>

              {/* CAMPO 2: CONTAINER INFORMATION (CONTENT) */}
              <div className="heavy-form-group">
                <input
                  id="content"
                  type="text"
                  placeholder=" "
                  className="formInput"
                  {...register("content", {
                    required: true,
                    maxLength: {
                      value: 240,
                      message: "Máximo 240 caracteres",
                    },
                  })}
                />
                <label htmlFor="content" className="formLabel">
                  Información del contenedor <span className="text-alert">*</span>
                </label>
                {errors.content?.type === "required" && isSubmitted && (
                  <p>Este campo es requerido</p>
                )}
                {errors.content?.type === "maxLength" && (
                  <p>{errors.content?.message}</p>
                )}
              </div>

              {/* CAMPO 3: AWB */}
              <div className="heavy-form-group">
                <input
                  id="awb"
                  type="text"
                  placeholder=" "
                  className="formInput"
                  maxLength={4}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                  }}
                  {...register("awb", {
                    required: true,
                    pattern: {
                      value: /^[0-9]{4}$/,
                      message: "Debe contener exactamente 4 números",
                    }
                  })}
                />
                <label htmlFor="awb" className="formLabel">
                  AWB (Últimos 4 dígitos) <span className="text-alert">*</span>
                </label>
                {errors.awb?.type === "required" && isSubmitted && (
                  <p>Este campo es requerido</p>
                )}
                {errors.awb?.type === "pattern" && (
                  <p>{errors.awb?.message}</p>
                )}
              </div>

              {/* CAMPO 4: TARIMAS */}
              <div className="heavy-form-group">
                <input
                  id="number_pallets"
                  type="text"
                  placeholder=" "
                  className="formInput"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                  }}
                  {...register("number_pallets", {
                    required: true,
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Solo se permiten números",
                    },
                  })}
                />
                <label htmlFor="number_pallets" className="formLabel">
                  Cantidad de tarimas <span className="text-alert">*</span>
                </label>
                {errors.number_pallets?.type === "required" && isSubmitted && (
                  <p>Este campo es requerido</p>
                )}
                {errors.number_pallets?.type === "pattern" && (
                  <p>{errors.number_pallets?.message}</p>
                )}
              </div>

              <div className="btn-containe" style={{ marginTop: '20px' }}>
                <button
                  type="submit"
                  onClick={() => {
                    formBtnClick = true;
                  }}
                  className={editIndex !== null ? "button-updated" : "button-add"}
                >
                  {editIndex !== null ? (
                    <>
                      <FaCircleCheck /> Actualizar embarque
                    </>
                  ) : (
                    <>
                      <IoMdAdd /> Agregar embarque
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default SetterCreditClientTable;